module.exports = __webpack_public_path__ + "static/media/chess-rook.0e35eb35.svg";